import { render, staticRenderFns } from "./PairedListCollectionCreator.vue?vue&type=template&id=fa04ae5c&"
import script from "./PairedListCollectionCreator.vue?vue&type=script&lang=js&"
export * from "./PairedListCollectionCreator.vue?vue&type=script&lang=js&"
import style0 from "./PairedListCollectionCreator.vue?vue&type=style&index=0&id=fa04ae5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports